module.exports = __webpack_public_path__ + "img/ami.2aac33e8.png";